import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import useMobile from "../../hooks/useMobile";
import DynamicToolTip from "../DynamicToolTip";
import { ITestimonyData, ITestimonyTitleData } from "../../exports/interfaces";

const Testimony = (props: { testimonyTitleData: ITestimonyTitleData[]; testimonyData: ITestimonyData[] }) => {
  const mobile = useMobile();
  return (
    <section className="testimonial-two">
      <div
        className="testimonial-two-bg"
        // style="background-image: url(assets/images/backgrounds/testimonial-two-bg.png);"
      ></div>
      <div className="container">
        <div className="row">
          <div className="col-xl-4">
            <div className="testimonial-two__left">
              <div className="section-title text-left">
                <span className="section-title__tagline">
                  {props?.testimonyTitleData[0]?.attributes?.Primary_Title}
                </span>
                <h2 className="section-title__title">
                  {props?.testimonyTitleData[0]?.attributes?.Secondary_Title}
                </h2>
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            <div className="testimonial-two__right">
              <div className="testimonial-two__carousel owl-carousel owl-theme">
                <div className="owl-nav">
                  <DynamicToolTip title="Previous">
                    <button type="button" className="owl-prev custom-prev">
                      <span className="fa fa-angle-right"></span>
                    </button>
                  </DynamicToolTip>
                  <DynamicToolTip title="Next">
                    <button type="button" className="owl-next custom-next">
                      <span className="fa fa-angle-right"></span>
                    </button>
                  </DynamicToolTip>
                </div>
                <Swiper
                  modules={[Navigation]}
                  slidesPerView={mobile ? 1 : 2}
                  grabCursor={true}
                  spaceBetween={20}
                  navigation={{
                    prevEl: ".custom-prev",
                    nextEl: ".custom-next",
                  }}
                  className="testimonial-swiper"
                >
                  {props?.testimonyData?.map((testimonial) => (
                    <SwiperSlide key={testimonial.id}>
                      <div className="testimonial-two__single">
                        <div className="testimonial-two__content">
                          <div className="testimonial-two__quote">
                            <span className="icon-quote"></span>
                          </div>
                          <p className="testimonial-two__text">
                            {testimonial.attributes.Description}
                          </p>
                        </div>
                        <div className="testimonial-two__client-info">
                          <div className="testimonial-two__client-img">
                            <img
                              src={`${process.env.REACT_APP_strapiUrl}${testimonial?.attributes?.Image?.data?.attributes?.url}`}
                              alt={testimonial.attributes.Name}
                            />
                          </div>
                          <div className="testimonial-two__client-details">
                            <h5 className="testimonial-two__client-name">
                              {testimonial.attributes.Name}
                            </h5>
                            <p className="testimonial-two__client-title">
                              {testimonial.attributes.Position}
                            </p>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimony;
